import { combineReducers } from 'redux';
import testData from '../data/test';
import {
  INIT_TEST_QUESTIONS,
  ADD_USER_RESPONSE,
  UPDATE_USER_RESPONSE,
  CREATE_RESULT,
  ADD_USER_EXTRA_RESPONSE
} from '../actions';

function tests(state = testData, action) {
  switch (action.type) {
    case INIT_TEST_QUESTIONS:
      return action.questions;
    default:
      return state;
  }
}

function response(state = {}, action) {
  switch (action.type) {
    case ADD_USER_RESPONSE:
      return {
        testId: action.testId,
        start: action.start
      };
    case UPDATE_USER_RESPONSE:
      if (state.testId !== action.testId) {
        return state;
      }
      return Object.assign({}, state, {
        theOther: action.theOther,
        end: action.end,
        tag: action.tag
      });
    default:
      return state;
  }
}

function responses(state = [], action) {
  switch (action.type) {
    case ADD_USER_RESPONSE:
      return [
        ...state,
        response(undefined, action)
      ];
    case UPDATE_USER_RESPONSE:
      return state.map(r =>
        response(r, action)
      );
    default:
      return state;
  }
}

function result(state = {}, action) {
  switch (action.type) {
    case CREATE_RESULT:
      return action.result;
    default:
      return state;
  }
}

function emotion(state = '', action) {
  switch (action.type) {
    case ADD_USER_EXTRA_RESPONSE:
      return action.response;
    default:
      return state;
  }
}

const reducer = combineReducers({
  tests,
  responses,
  result,
  emotion
});

export default reducer;



// WEBPACK FOOTER //
// ./app/reducers/index.js